var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedSubjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.634338,
    y: 0.843384,
    width: 46.8138,
    height: 46.8138,
    rx: 23.4069,
    fill: "#40499D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3556 20.1111V31.2193C14.3556 31.2193 18.8079 31.0536 23.9906 33.6001C29.1733 31.0536 33.6257 31.2193 33.6257 31.2193V20.1111C33.6257 20.1111 28.3707 20.1111 23.9906 22.4919C19.6105 20.1111 14.3556 20.1111 14.3556 20.1111Z",
    fill: "#40499D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9906 20.1089C25.587 20.1089 26.8811 18.8148 26.8811 17.2184C26.8811 15.622 25.587 14.3279 23.9906 14.3279C22.3942 14.3279 21.1001 15.622 21.1001 17.2184C21.1001 18.8148 22.3942 20.1089 23.9906 20.1089Z",
    fill: "#40499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedSubjects);
export default __webpack_public_path__ + "static/media/CompletedSubjects.d1ff85d9c9b5c4e934165ed7e9b2bfed.svg";
export { ForwardRef as ReactComponent };